<template>
    <el-popover 
        trigger="click" 
        placement="left" 
        width="800px"
        v-model:visible="visible">
        <template #reference>
            <ComInfoButton></ComInfoButton>
        </template>
        <template v-if="visible">
            <ComHuonekorttiNimikeHistoriaItem :data="historiaNimikkeet[active]" />
            <el-row>
                <ul style="padding-left: 0px">
                    <li v-for="(historia, index) in historiaNimikkeet" :key="historia.id" style="display: inline-block">
                        <el-button :type="buttonColor(historia.tyyppi)" @click="active = index" text>
                            {{ historia.aika }}
                        </el-button>
                    </li>
                </ul>
            </el-row>
            <el-row>
                <el-col>
                    <el-button @click="visible = false">Sulje</el-button>
                </el-col>
            </el-row>
        </template>
    </el-popover>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue"
import ComHuonekorttiNimikeHistoriaItem from "./ComHuonekorttiNimikeHistoriaItem.vue"
import ComInfoButton from "@/components/common/buttons/ComInfoButton.vue"
import { useHuonekorttiHistoriaMethods } from "@/methods/huonekorttiHistoriaComposables"
import { useHistoriaComponent } from "../historia"

const props = defineProps<{
    id: number,
    huonekorttiId: number
}>()

const { historia, huonekortti, id:_huonekorttiId } = useHistoriaComponent()
const { diffAllHistoriaNimike, tyyppiColor: buttonColor } = useHuonekorttiHistoriaMethods()
const visible = ref(false)
const active = ref(0)

const historiaNimikkeet = computed(() => {
    if (visible.value) {
        const hn = historia.value?.nimikkeet
        const nimike = huonekortti?.value?.nimikkeet?.find((n) => n.id == props.id)

        if (hn) {
            return diffAllHistoriaNimike(hn, props.id, nimike)
        }
    }

    return []
})

watch(() => props.huonekorttiId, val => {
    _huonekorttiId.value = val
}, { immediate: true })
</script>
